
import React, { Component, useEffect } from "react";
import { Button, Grid, ThemeProvider } from '@material-ui/core';
import VitalsMDTheme from './VitalsMDTheme';
import navlogo from '../images/vitalsmd-portal-nav-logo.svg';
import './LoginPage.css';
import LoginButton from "./LoginButton";
import { makeStyles } from '@material-ui/core/styles';
import { Label } from "@material-ui/icons";
import { getGlobalIsDemoMode } from '../store/APIStore';

const useStyles = makeStyles((theme) => ({
    root: {
        color: "#fff",
        fontSize: "0.875rem",
        textAlign: "center",
        marginBottom: "2"
    },
}));

const LoginPage = (props : any) => {
    const classes = useStyles();
    console.log("hello");
    console.log(props.location.pathname)
    const redirectPath = props.location.pathname;
    const isDemoMode = getGlobalIsDemoMode();

    console.log("Demo mode? " + isDemoMode);


        

    useEffect(() => {
        document.title = "VitalsMD Portal"
    }, []);


    return (
        <ThemeProvider theme={VitalsMDTheme}>
            <div>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    className="logincontainer"

                >

                    <Grid item xs={12}>
                        <img src={navlogo} alt="Logo" width="100%" />
                 
                    </Grid>
                    <Grid item xs={7} sm={6}>
                        <LoginButton redirect={redirectPath} />
                    </Grid>
                    <Grid item xs={8} sm={6} lg={8}>
                        <label className={classes.root}>For assistance, contact us at 855-489-8141 or servicedesk@hnihc.com</label>
                    </Grid>
                </Grid>
            </div>
        </ThemeProvider>
    );

}

export default LoginPage;


